module.exports = __webpack_public_path__ + "media/promo/hoch2023ru/images/rec-1-872c7b090ba4d986cb03f3b1ce64bf4d.jpg";